<!--
 * @Version: 1.0.0
 * @Description: file content
 * @Autor: zhiqiang.xia@dsicm.com
 * @Date: 2021-05-25 11:20:50
 * @LastEditors: zhiqiang.xia@dsicm.com
 * @LastEditTime: 2023-02-14 18:56:03
 * @FilePath: \新建文件夹 (2)\dsicm-admin-web\src\views\pushManagement\component\pushPackage\index.vue
 * @tips: 推送服务包管理
-->
<template>
  <div class="addplan">
    <div class="top">
      <div class="text"><span>推送管理 / 推送服务包管理 / </span><span>{{ edit? '编辑': '新增' }}</span></div>
      <div><el-button type="primary" size="mini" style="background: #1a7bfc; border-color: #1a7bfc"
          @click="back(false)">返回</el-button></div>
    </div>
    <div class="content">
      <div class="content-list">
        <el-scrollbar style="height: 100%; font-size: 12px; width: 100%">
          <div class="list-two">
            <el-form :model="form" :rules="rules" ref="ruleForm" label-width="120px" size="small" class="demo-ruleForm">
              <el-form-item label="模板类型：" prop="templateType">
                <el-select class="input-w" v-model="form.templateType" placeholder="请选择" @change="pushTypeChange">
                  <el-option label="链-IM房间" :value="1"></el-option>
                  <el-option label="客服-IM房间" :value="2"></el-option>
                  <el-option label="公众号消息" :value="3"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="模板名称：" prop="pushName">
                <el-input class="input-w" v-model.trim="form.pushName" placeholder="请输入" maxlength="20"
                  show-word-limit></el-input>
              </el-form-item>
              <el-form-item label="模板说明：" prop="templateDescribe">
                <el-input class="input-w" v-model.trim="form.templateDescribe" placeholder="请输入" maxlength="20"
                  show-word-limit></el-input>
              </el-form-item>
              <el-form-item v-if="form.templateType == 3" label="公众号：" prop="officialNumber">
                <el-select class="input-w" v-model="form.officialNumber" placeholder="请选择" @change="publicChange">
                  <el-option v-for="(item, index) in publicList" :key="index" :label="item.appName"
                    :value="item.appId"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item v-else label="消息模板ID：" prop="templateId">
                <el-select class="input-w" v-model="form.templateId" placeholder="请选择">
                  <el-option v-for="(item, index) in programList" :label="item.templateName" :value="item.templateId"
                    :key="index"></el-option>
                </el-select>
              </el-form-item>
              <div v-if="form.templateType == 3">
                <el-form-item label="选择模板：" v-if="form.officialNumber" prop="templateItem">
                  <el-select class="input-w" value-key="id" v-model="form.templateItem" placeholder="请选择"
                    @change="templateItemChange">
                    <el-option v-for="(item, index) in templateChildrenList" :label="item.remark" :value="item"
                      :key="index"></el-option>
                  </el-select>
                </el-form-item>
                <div v-if="form.pushWechatTemplateList && form.templateItem && form.officialNumber">
                  <div v-for="(item, index) in form.pushWechatTemplateList" :key="index">
                    <el-form-item :label="item.title + '：'" v-if="item.open">
                      <el-input class="input-w" maxlength="20" show-word-limit v-model.trim="item.value"></el-input>
                    </el-form-item>
                  </div>
                </div>
              </div>
              <el-form-item label="提示说明：" prop="describe" v-if="form.templateType != 3">
                <el-input class="input-w" v-model.trim="form.describe" placeholder="请输入" maxlength="20"
                  show-word-limit></el-input>
              </el-form-item>
              <el-form-item label="IM 文案：" prop="msgBody">
                <el-input class="input-w" @input="change($event)" v-model.trim="form.msgBody"
                  placeholder="请输入"></el-input>
              </el-form-item>
              <el-form-item label="推送时间：" prop="pushTimeType">
                <el-radio-group v-model="pushTime.type" @change="radioChange">
                  <div class="radioBox">
                    <el-radio :label="1">当天</el-radio>
                    <el-time-select :disabled="pushTime.type != 1" class="radioBoxItem" @input="change($event)"
                      v-model="pushTime.time1" :picker-options="{ start: '00:00', step: '01:00', end: '23:59' }"
                      placeholder="选择时间"></el-time-select>
                  </div>
                  <div class="radioBox">
                    <el-radio :label="2">匹配后</el-radio>
                    <el-input :disabled="pushTime.type != 2" @input="change($event, 1)" class="radioBoxItem"
                      placeholder="请输入" v-model="pushTime.day1" maxlength="3">
                      <template slot="append">天</template>
                    </el-input>
                    <el-time-select @input="change($event)" :disabled="pushTime.type != 2" class="radioBoxItem"
                      v-model="pushTime.time2" :picker-options="{ start: '00:00', step: '01:00', end: '23:59' }"
                      placeholder="选择时间"></el-time-select>
                  </div>
                  <div class="radioBox">
                    <el-radio :label="3">匹配后间隔</el-radio>
                    <el-input :disabled="pushTime.type != 3" @input="change($event, 2)" class="radioBoxItem"
                      placeholder="请输入" v-model.trim="pushTime.day2" maxlength="3">
                      <template slot="append">天</template>
                    </el-input>
                    <el-button type="text" class="e-btn">上限</el-button>
                    <el-input :disabled="pushTime.type != 3" @input="change($event, 3)" class="radioBoxItem"
                      style="width: 20.5%;" placeholder="请输入" v-model="pushTime.pushLimit" maxlength="3">
                      <template slot="append">次</template>
                    </el-input>
                    <el-time-select :disabled="pushTime.type != 3" class="radioBoxItem" v-model="pushTime.time3"
                      @input="change($event)" :picker-options="{ start: '00:00', step: '01:00', end: '23:59' }"
                      placeholder="选择时间"></el-time-select>
                  </div>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="其他类型：" prop="tip">
                <el-popover placement="top-end" width="342" trigger="click">
                  <div class="tip-box">
                    <div class="tip-item" v-for="(item, index) in tipItems" :key="index" @click="otherTypes(item.name)">
                      <div class="tip-item-icon">
                        <img class="tip-img" :src="item.ImgPath" alt="">
                      </div>
                      <div class="tip-item-text">{{ item.name }}</div>
                      <BaseUploadFile :isCompress='true' class="upInput"  :fileType="['png', 'jpg', 'jpeg']" v-if="item.id==9" :fileSize="10"
                        :isShowTip="false" :cropWidth="250" :cropHeight="200" message="" :multiple='true' :size="60"
                        action="/api/dsicm-contact-platform/feign/file/upload" :responseFn="handleSharingPicUrlResponse"
                        :data="{ path: 'dsicm-doctor', type: 'image' }" v-model="upPicUrl">
                      </BaseUploadFile>
                    </div>
                  </div>
                  <el-button plain class="addBtn" slot="reference">+ 添加</el-button>
                </el-popover>
              </el-form-item>
              <el-form-item prop="tip">
                <div id="list-tip-box">
                  <div class="list-item" v-for="(item, index) in form.additionalContentList" :key="index">
                    <div class="tag">
                      <span>{{ item.typeName }}</span>
                    </div>
                    <el-image class="flex preview-img" v-if="item.typeId == 9" :src="imgUrl+item.body.content"
                      :preview-src-list="[imgUrl+item.body.content]">
                    </el-image>
                    <div v-else class="flex">{{ item.body.content ? item.body.content : item.body.title }}</div>
                    <img  @click="delContent(index)" src="@/assets/images/tooltipsIcon/listIcon.png"
                      alt="">
                  </div>
                </div>
              </el-form-item>
            </el-form>
            <div class="uploadBtn">
              <el-button class="button-w" @click="resect()" size="small">重置</el-button>
              <el-button class="button-w" @click="save()" type="primary" size="small">保存</el-button>
            </div>
          </div>
          <div style="height: 50px;"></div>
        </el-scrollbar>
      </div>
    </div>
    <!-- 在线教程弹窗 -->
    <OnlineCourse ref="courseDialog" @receiveParams="receiveParams" />
    <!-- 宣传患教弹窗 -->
    <Education ref="educationDialog" @receiveParams="receiveParams" />
    <!-- 选择问卷弹窗 -->
    <AddQuestionDialog v-if="questionCom.visible" :showAddQuestion.sync="questionCom.visible" :title="questionCom.title"
      @receiveParams="receiveParams" :showCompanyBtn="true" />
    <!-- 推荐服务 -->
    <ServiceRecommon v-if="serviceRecommon.visible" :showAddQuestion.sync="serviceRecommon.visible"
      :title="serviceRecommon.title" @receiveParams="receiveParams" :planPage="planPageEmit" />
    <!-- 病历夹 -->
    <RecordFolder ref="folderDialog" @receiveParams="receiveParams" />
  </div>
</template>

<script>
import local from "@/utils/local.js";
import OnlineCourse from "../../dialogComponent/onlineCourse.vue";
import Education from "../../dialogComponent/education.vue";
import AddQuestionDialog from "@/views/ToolMaintenance/component/addQuestionDialog.vue";
import ServiceRecommon from "@/views/treatment/components/serviceRecommon/index";
import RecordFolder from "../../dialogComponent/recordFolder.vue";
import {
  apiPublicList,
  queryMiniprogramList,
  queryByAppId
} from "../../api/index";
export default {
  components: {
    OnlineCourse,
    Education,
    AddQuestionDialog,
    ServiceRecommon,
    RecordFolder
  },
  data() {
    return {
      imgUrl: process.env.VUE_APP_OSS_URL,
      upPicUrl: "",
      wxUploadList: [],
      spareList: [],
      // 推荐服务
      serviceRecommon: {
        visible: false,
        title: "推荐服务",
        param: {}
      },
      questionCom: {
        visible: false,
        params: {},
        title: "选择问卷"
      },
      planPageEmit: true,
      edit: false,
      tipItems: [
        {
          ImgPath: require("@/assets/images/tooltipsIcon/book.png"),
          name: "在线教程",
          id: 2
        },
        {
          ImgPath: require("@/assets/images/tooltipsIcon/book1.png"),
          name: "宣传患教",
          id: 3
        },
        {
          ImgPath: require("@/assets/images/tooltipsIcon/book2.png"),
          name: "问卷选择",
          id: 4
        },
        {
          ImgPath: require("@/assets/images/tooltipsIcon/book4.png"),
          name: "推荐服务",
          id: 6
        },
        {
          ImgPath: require("@/assets/images/tooltipsIcon/book5.png"),
          name: "病历夹",
          id: 7
        },
        {
          ImgPath: require("@/assets/images/tooltipsIcon/book3.png"),
          name: "症状卡片",
          id: 8
        },
        {
          ImgPath: require("@/assets/images/tooltipsIcon/book6.png"),
          name: "发送图片",
          id: 9
        }
      ],
      form: {
        pushName: "",
        templateDescribe: "",
        describe: "",
        templateId: "",
        additionalContentList: [],
        pushTemplateRule: {},
        officialNumber: "",
        templateType: 1,
        pushWechatTemplateList: [],
        msgBody: "",
        templateItem: null
      },
      templateChildrenList: [],
      publicList: [],
      programList: [],
      pushTime: {
        type: 1,
        day: null,
        time: null,
        pushLimit: null,
        time1: null,
        time2: null,
        time3: null,
        day1: null,
        day2: null
      },
      rules: {
        name: [{ required: true, message: "请输入", trigger: "change" }],
        templateType: [
          { required: true, message: "请输入", trigger: "change" }
        ],
        pushName: [{ required: true, message: "请输入", trigger: "change" }],
        templateId: [{ required: true, message: "请输入", trigger: "change" }],
        describe: [{ required: true, message: "请输入", trigger: "change" }],
        officialNumber: [
          { required: true, message: "请输入", trigger: "change" }
        ],
        msgBody: [{ required: true, message: "请输入", trigger: "blur" }],
        templateItem: [
          { required: false, message: "请输入", trigger: "change" }
        ]
      },
      dataform: {}
    };
  },

  created() {},
  mounted() {
    //edit = 1 = 新增 | edit = 2 = 编辑
    this.edit = this.$route.query.edit == 1 ? false : true;
    this.dataform = JSON.parse(local.get("TEMPLATE_DTOLIST"))
      ? JSON.parse(local.get("TEMPLATE_DTOLIST"))
      : {};
    if (this.edit) {
      this.form = this.dataform.templateList[this.$route.query.index];
      this.form.templateItem = this.form.pushWechatTemplateList
        ? this.form.pushWechatTemplateList
        : null;
      if (this.form.additionalContentList == null) {
        this.form.additionalContentList = [];
      }
      if (this.form.pushTemplateRule.type == 1) {
        this.form.pushTemplateRule.time1 = this.form.pushTemplateRule.time;
      } else if (this.form.pushTemplateRule.type == 2) {
        this.form.pushTemplateRule.time2 = this.form.pushTemplateRule.time;
        this.form.pushTemplateRule.day1 = this.form.pushTemplateRule.day;
      } else if (this.form.pushTemplateRule.type == 3) {
        this.form.pushTemplateRule.time3 = this.form.pushTemplateRule.time;
        this.form.pushTemplateRule.day2 = this.form.pushTemplateRule.day;
      }
      this.pushTime = this.form.pushTemplateRule;
      this.publicChange(this.form.officialNumber, 1);
    }
    this.getPublicList();
  },
  methods: {
    handleSharingPicUrlResponse(end) {
      let index = end.data.indexOf("/");
      this.receiveParams({
        emitType: "发送图片",
        content: end.data,
        title: end.data.slice(index + 1)
      });
    },
    //选择类型触发
    pushTypeChange() {
      this.form.pushName = "";
      this.form.templateDescribe = "";
      this.form.templateId = "";
      this.form.describe = "";
      this.form.msgBody = "";
      this.form.officialNumber = "";
      this.$nextTick(() => {
        this.radioChange();
      });
    },
    //选择模板
    templateItemChange(e) {
      console.log(this.templateChildrenList);
      console.log(12312312, this.spareList);
      this.templateChildrenList = this.spareList;
      this.form.pushWechatTemplateList = e.parameterDescribe;
      this.form.templateId = e.templateId;
    },
    //重置表单数据
    resect() {
      this.form = {
        name: "",
        pushName: "",
        templateDescribe: "",
        describe: "",
        templateId: "",
        additionalContentList: [],
        pushTemplateRule: {},
        id: this.edit ? this.id : null,
        officialNumber: "",
        templateType: 1,
        pushWechatTemplateList: [],
        msgBody: ""
      };
      this.pushTime = {
        day: null,
        time: null,
        pushLimit: null,
        time1: null,
        time2: null,
        time3: null,
        day1: null,
        day2: null,
        type: 1
      };
    },
    //获取与小程序公众号列表
    getPublicList() {
      apiPublicList().then(res => {
        this.publicList = res.data;
      });
      queryMiniprogramList().then(res => {
        this.programList = res.data;
      });
    },
    //选择公众号弹出对应模板
    publicChange(e, type) {
      this.form.templateItem = null;
      if (!type) {
        this.form.pushWechatTemplateList = [];
      }
      queryByAppId(e).then(res => {
        this.spareList = res.data;
        this.templateChildrenList = res.data;
        console.log("第一步备用", this.spareList);
        console.log("第一步", this.templateChildrenList);
        this.templateChildrenList.forEach(item => {
          if (this.form.templateId == item.templateId) {
            if (type) {
              item.parameterDescribe = this.form.pushWechatTemplateList;
            }
            this.form.templateItem = item;
            console.log("便利ITEM", item);
            // this.form.pushWechatTemplateList = item.parameterDescribe;
          }
        });
      });
    },
    //选择其他类型
    otherTypes(e) {
      switch (e) {
        case "在线教程":
          this.$refs.courseDialog.$emit("openDialog");
          break;
        case "宣传患教":
          this.$refs.educationDialog.$emit("openDialog");
          break;
        case "问卷选择":
          this.questionCom.visible = true;
          break;
        case "推荐服务":
          this.serviceRecommon.visible = true;
          break;
        case "症状卡片":
          this.receiveParams({
            emitType: "症状卡片"
          });
          break;
        case "病历夹":
          this.$refs.folderDialog.$emit("openDialog");
          break;
        default:
          break;
      }
    },
    //选择推送时间
    radioChange() {
      this.pushTime.day = null;
      this.pushTime.time = null;
      this.pushTime.pushLimit = null;
      this.pushTime.time1 = null;
      this.pushTime.time2 = null;
      this.pushTime.time3 = null;
      this.pushTime.day1 = null;
      this.pushTime.day2 = null;
      this.$forceUpdate();
    },
    //返回上一级
    back(type) {
      if (!type) {
        //不携带参数
        this.$router.back();
      }
    },
    //删除其他类型数组内容
    delContent(index) {
      this.form.additionalContentList.splice(index, 1);
    },
    //input输入不生效
    change(e, type) {
      if (type == 1) {
        this.pushTime.day1 = e.replace(/[^\d]/g, "");
      } else if (type == 2) {
        this.pushTime.day2 = e.replace(/[^\d]/g, "");
      } else if (type == 3) {
        this.pushTime.pushLimit = e.replace(/[^\d]/g, "");
      }
      this.$forceUpdate();
    },
    //接收弹窗参数
    receiveParams(params) {
      switch (params.emitType) {
        case "在线教程":
          this.form.additionalContentList.push({
            body: {
              content: null,
              id: params.id,
              title: params.courseName
            },
            typeId: 2,
            typeName: "在线教程"
          });
          break;
        case "宣传患教":
          this.form.additionalContentList.push({
            body: {
              content: null,
              id: params.id,
              title: params.title
            },
            typeId: 3,
            typeName: "宣传患教"
          });
          break;
        case "问卷选择":
          this.form.additionalContentList.push({
            body: {
              content: null,
              id: params.id,
              title: params.title
            },
            typeId: 4,
            typeName: "问卷选择"
          });
          break;
        case "推荐服务":
          this.form.additionalContentList.push({
            body: {
              content: null,
              id: params.id,
              title: params.name
            },
            typeId: 6,
            typeName: "推荐服务"
          });
          break;
        case "症状卡片":
          this.form.additionalContentList.push({
            body: {
              content: null,
              id: null,
              title: null
            },
            typeId: 8,
            typeName: "症状卡片"
          });
          break;
        case "病历夹":
          this.form.additionalContentList.push({
            body: {
              content: params.content,
              id: null,
              title: params.title
            },
            typeId: 7,
            typeName: "病历夹"
          });
          break;
        case "发送图片":
          this.form.additionalContentList.push({
            body: {
              content: params.content,
              id: null,
              title: params.title
            },
            typeId: 9,
            typeName: "发送图片"
          });
          break;
        default:
          break;
      }
    },
    //保存
    save() {
      console.log("类型结果", this.form.additionalContentList);
      // debugger
      let flag = true;
      if (this.form.templateType == 3 && !this.form.templateItem) {
        this.$message.error("请选择模板");
        return;
      }
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.form.pushTemplateRule = {
            day:
              this.pushTime.type == 2
                ? this.pushTime.day1
                : this.pushTime.type == 3
                ? this.pushTime.day2
                : null,
            pushLimit: this.pushTime.pushLimit,
            time:
              this.pushTime.type == 1
                ? this.pushTime.time1
                : this.pushTime.type == 2
                ? this.pushTime.time2
                : this.pushTime.type == 3
                ? this.pushTime.time3
                : null,
            type: this.pushTime.type
          };
          if (this.form.pushTemplateRule.day === 0) {
            this.form.pushTemplateRule.day = "0";
          }
          if (this.form.pushTemplateRule.pushLimit === 0) {
            this.form.pushTemplateRule.pushLimit = "0";
          }
          if (
            this.form.pushTemplateRule.type == 1 &&
            !this.form.pushTemplateRule.time
          ) {
            this.$message.error("请输入推送时间");
            return;
          } else if (
            this.form.pushTemplateRule.type == 2 &&
            (!this.form.pushTemplateRule.time ||
              !this.form.pushTemplateRule.day)
          ) {
            this.$message.error("请输入推送时间");
            return;
          } else if (
            this.form.pushTemplateRule.type == 3 &&
            (!this.form.pushTemplateRule.day ||
              !this.form.pushTemplateRule.pushLimit ||
              !this.form.pushTemplateRule.time)
          ) {
            this.$message.error("请输入推送时间");
            return;
          }
          if (this.form.templateType != 3) {
            this.programList.forEach(item => {
              if (item.templateId == this.form.templateId) {
                this.form.officialNumber = item.appId;
              }
            });
            this.form.pushWechatTemplateList = [];
          } else {
            this.form.pushWechatTemplateList.forEach(item => {
              if (!item.value && item.open) {
                flag = false;
              }
            });
          }
          if (flag) {
            if (this.edit) {
              this.dataform.templateList[this.$route.query.index] = this.form;
              local.set("TEMPLATE_DTOLIST", JSON.stringify(this.dataform));
              this.$router.back();
            } else {
              this.dataform.templateList.push(this.form);
              local.set("TEMPLATE_DTOLIST", JSON.stringify(this.dataform));
              this.$router.back();
            }
          } else {
            this.$message.error("模板内容不能为空");
            return;
          }
        } else {
          return false;
        }
      });
    }
  },
  filters: {
    //其他类型
    typeFilter(e) {
      switch (e) {
        case 2:
          return "在线教程";
        case 3:
          return "宣传患教";
        case 4:
          return "问卷选择";
        case 6:
          return "推荐服务";
        case 7:
          return "病历夹";
        default:
          return "--";
      }
    }
  }
};
</script>
<style lang="less" scoped>
.addplan {
  height: 100%;
  width: 100%;
  background: #f8f8f8;

  .top {
    width: 100%;
    background: #fff;
    padding-left: 25px;
    display: flex;
    justify-content: space-between;
    padding: 24px 24px 15px 24px;
  }

  .content {
    height: 88vh;
    width: 100%;
    padding: 10px;

    .content-list {
      background: #fff;
      border-radius: 5px;
      height: 100%;
      width: 100%;
      padding: 30px 0px 0px 40px;
    }
  }
}

.addBtn {
  border: 1px dashed #dcdfe6;
  width: 30%;
}

.radioBox {
  display: flex;
  align-items: center;
  margin-bottom: 20px;

  .radioBoxItem {
    width: 26.5%;
    margin-right: 10px;
  }

  .interval {
    margin-right: 10px;
  }

  .e-btn {
    color: #000;
    font-size: 14px;
    margin-right: 10px;
  }
}

.tip-box {
  display: flex;
  flex-wrap: wrap;

  .tip-item {
    width: 25%;
    text-align: center;
    margin-bottom: 20px;
    position: relative;
    .upInput {
      position: absolute;
      top: 0;
      left: 0;
      border: solid;
      width: 100%;
      height: 100%;
      opacity: 0;
    }
    .tip-item-icon {
      cursor: pointer;
      width: 26px;
      height: 26px;
      background: #363f4d;
      border-radius: 16px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 0 auto;
      margin-bottom: 5px;

      .tip-img {
        width: 17px;
        height: 15px;
      }
    }

    .tip-item-text {
      cursor: pointer;
      font-size: 12px;
    }
  }
}

/deep/.el-scrollbar__wrap {
  overflow-x: hidden;
}

.text {
  color: #333333;
  font-size: 14px;

  span:nth-child(2) {
    color: #333;
  }

  span:nth-child(1) {
    color: #999;
  }
}

#list-tip-box {
  width: 30%;

  .list-item {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    /deep/.preview-img img {
      width: 30px;
      height: 30px;
    }
    /deep/.el-image-viewer__canvas img {
      width: auto;
      height: auto;
    }
    :nth-last-child {
      margin-bottom: 0;
    }

    .tag {
      background: #eff6ff;
      border-radius: 4px;
      height: 24px;
      display: flex;
      align-items: center;
      justify-content: center;

      span {
        font-size: 12px;
        color: #1a7bfc;
        margin: 6px;
      }
    }

    .flex {
      flex: 1;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      font-size: 12px;
      margin: 0px 10px 0px 10px;
    }

    :nth-child(3) {
      width: 24px;
      height: 24px;
    }
  }
}

.input-w {
  width: 30%;
}

.button-w {
  width: 110px;
}

.uploadBtn {
  width: 30%;
  text-align: center;
  margin-top: 22px;
}
</style>
